import React from 'react';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Alert from '@cloudscape-design/components/alert';
import Button from '@cloudscape-design/components/button';
import AuthCard from '../components/AuthCard';

interface RequestReceivedScreenProps {
    email: string;
    onBackToLogin: () => void;
}

/**
 * Shown after an onboarding request is submitted. Self sign-up is disabled, so
 * there's no email-verification step here — the user waits for an approver.
 * Once approved, Cognito emails a temporary password to finish setup.
 */
export default function RequestReceivedScreen({
    email,
    onBackToLogin,
}: RequestReceivedScreenProps) {
    return (
        <AuthCard title="Request received" subtitle="We'll be in touch">
            <SpaceBetween size="l">
                <Alert type="success">
                    Thanks — your request for <strong>{email}</strong> has been received. Once an
                    administrator approves it, you&apos;ll get an email with a temporary password
                    and instructions to finish setting up your account.
                </Alert>
                <Button variant="primary" onClick={onBackToLogin}>
                    Back to sign in
                </Button>
            </SpaceBetween>
        </AuthCard>
    );
}
